import React from "react";

const CustomFooter = () => {
	return <div>LEADER Learning Centre © All rights reserved</div>;
};

export default CustomFooter;
